import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

type GridLayoutOneIconProps = IconClientSVGProps & {
  filled?: boolean;
};

export const GridLayoutOneIcon = forwardRef<
  SVGSVGElement,
  GridLayoutOneIconProps
>(({ filled, label, ...props }, ref) => {
  return (
    <Icon label={label}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        ref={ref}
        {...props}
      >
        {filled ? (
          <>
            <path d="M2 2H18V18H2V2Z" fill="currentColor" />
            <path
              d="M2 2V1.5H1.5V2H2ZM18 2H18.5V1.5H18V2ZM18 18V18.5H18.5V18H18ZM2 18H1.5V18.5H2V18ZM2 2.5H18V1.5H2V2.5ZM17.5 2V18H18.5V2H17.5ZM18 17.5H2V18.5H18V17.5ZM2.5 18V2H1.5V18H2.5Z"
              fill="currentColor"
            />
          </>
        ) : (
          <path
            d="M2 2V1.5H1.5V2H2ZM18 2H18.5V1.5H18V2ZM18 18V18.5H18.5V18H18ZM2 18H1.5V18.5H2V18ZM2 2.5H18V1.5H2V2.5ZM17.5 2V18H18.5V2H17.5ZM18 17.5H2V18.5H18V17.5ZM2.5 18V2H1.5V18H2.5Z"
            fill="currentColor"
          />
        )}
      </svg>
    </Icon>
  );
});

GridLayoutOneIcon.displayName = "GridLayoutOneIcon";
